<template>
    <div class="choose-people-container">
        <div class="choose-people-link">
            <el-link @click="openPeople" type="primary" :underline="false">+{{ showTitle }}</el-link>
        </div>
        <div v-if="checkList.length !== 0" class="choose-people-tags">
            <el-tag type="info" @close="tagClose(tag)" style="margin-right: 10px;margin-bottom: 5px;"
                     v-for="tag in checkList" :key="tag.userId" class="mx-1" closable>
                {{ tag.expertName ? tag.expertName : tag.trueName }}
                <span v-if="tag.username">{{ '-' + tag.username }}</span>
            </el-tag>
        </div>

        <el-dialog :title="showTitle" v-model="isShowChooseUser" width="720px" @close="canceladdPeo">
            <div class="choose-people-body">
                <div class="org-list-container">
                    <div class="org-list-title">组织机构</div>
                    <div class="org-list-content">
                        <div class="org-item" :class="{'org-item-active': selectedOrgId === ''}" @click="selectOrg('')">
                            全部
                        </div>
                        <div class="org-item" v-for="org in authOrgList" :key="org.orgId"
                             :class="{'org-item-active': selectedOrgId === org.orgId}"
                             @click="selectOrg(org.orgId)">
                            {{ org.orgName }}
                        </div>
                    </div>
                </div>
                <div class="user-list-container">
                    <div class="user-search-box">
                        <el-input v-model="searchKey" placeholder="请输入姓名" clearable @keyup.enter="handleSearch">
                            <template #append>
                                <el-button @click="handleSearch">
                                    <el-icon><Search /></el-icon>
                                </el-button>
                            </template>
                        </el-input>
                    </div>
                    <div class="user-list-content">
                        <div class="user-grid">
                            <div class="user-card" :class="{'user-card-active': item.checked, 'user-card-disabled': isDisabled(item.userId)}"
                                 v-for="item in filteredUserList" :key="item.userId" @click="handleCardClick(item)">
                                <div class="user-card-check">
                                    <el-checkbox :disabled="isDisabled(item.userId)" v-model="item.checked" @click.stop @change="(val) => handleUserCheckChange(val, item)"></el-checkbox>
                                </div>
                                <div class="user-card-info">
                                    <div class="user-card-name">{{ item.expertName ? item.expertName : item.trueName }}</div>
                                    <div class="user-card-phone">{{ item.username || '-' }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="filteredUserList.length === 0" class="user-empty">暂无数据</div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dis-flex-row-center">
                    <el-button type="primary" @click="confirmSelect">确 定</el-button>
                    <el-button @click="canceladdPeo">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { queryManagerOrgAndUser } from "@/api/admin/org";

export default {
    name: 'choosePeople',
    emits: ['change', 'gxDisable'],
    props: {
        radio: {
            type: Boolean,
            default: false
        },
        showTitle: {
            type: String,
            default: '选择人员'
        },
        noShowIdList: {
            type: Array,
            default: () => []
        },
        disabledList: {
            type: Array,
            default: () => []
        }
    },
    created() {
        this.getUserList();
    },
    data() {
        return {
            isShowChooseUser: false,
            checkList: [],
            authOrgList: [],
            userList: [],
            filteredUserList: [],
            selectedOrgId: '',
            tempCheckList: [],
            searchKey: '',
            disabledList: [],
        }
    },
    methods: {
        getUserList() {
            queryManagerOrgAndUser().then(res => {
                if (res.data && res.data.code === 1) {
                    this.authOrgList = res.data.data.orgList || [];
                    this.userList = this.formatUserList(res.data.data.userList || []);
                    this.filterUserList();
                }
            })
        },
        formatUserList(list) {
            return list.filter(e => {
                return this.noShowIdList.length === 0 || !this.noShowIdList.includes(e.userId);
            }).map(e => {
                return {
                    ...e,
                    checked: this.isChecked(e.userId)
                }
            })
        },
        isChecked(userId) {
            return this.tempCheckList.some(e => e.userId === userId);
        },
        filterUserList() {
            let list = this.userList;
            if (this.selectedOrgId !== '') {
                list = list.filter(e => e.orgId === this.selectedOrgId);
            }
            if (this.searchKey.trim() !== '') {
                const key = this.searchKey.trim();
                list = list.filter(e => {
                    const name = (e.expertName || e.trueName || '').toLowerCase();
                    return name.includes(key.toLowerCase());
                });
            }
            this.filteredUserList = list;
        },
        handleSearch() {
            this.filterUserList();
        },
        selectOrg(orgId) {
            this.selectedOrgId = orgId;
            this.filterUserList();
        },
        handleCardClick(row) {
            if (this.isDisabled(row.userId)) return;
            row.checked = !row.checked;
            this.handleUserCheckChange(row.checked, row);
        },
        handleUserCheckChange(checked, row) {
            if (this.isDisabled(row.userId)) return;
            if (this.radio) {
                // 单选模式：只允许选中一个
                this.userList.forEach(e => {
                    e.checked = false;
                });
                this.tempCheckList = [];
                if (checked) {
                    row.checked = true;
                    this.tempCheckList.push(row);
                }
            } else {
                if (checked) {
                    if (!this.tempCheckList.some(e => e.userId === row.userId)) {
                        this.tempCheckList.push(row);
                    }
                } else {
                    this.tempCheckList = this.tempCheckList.filter(e => e.userId !== row.userId);
                }
            }
        },
        tagClose(tag) {
            this.checkList = this.checkList.filter(e => e.userId !== tag.userId);
            this.syncCheckedStatus();
            this.$emit('change', this.checkList);
            this.$emit('gxDisable', this.checkList);
        },
        openPeople() {
            this.tempCheckList = JSON.parse(JSON.stringify(this.checkList));
            this.selectedOrgId = '';
            this.searchKey = '';
            this.userList = this.formatUserList(this.userList);
            this.filterUserList();
            this.isShowChooseUser = true;
        },
        canceladdPeo() {
            this.isShowChooseUser = false;
        },
        confirmSelect() {
            this.checkList = JSON.parse(JSON.stringify(this.tempCheckList));
            this.syncCheckedStatus();
            this.$emit('change', this.checkList);
            this.$emit('gxDisable', this.checkList);
            this.isShowChooseUser = false;
        },
        isDisabled(userId) {
            return this.disabledList.some(e => e.userId === userId);
        },
        syncCheckedStatus() {
            this.userList.forEach(e => {
                e.checked = this.checkList.some(item => item.userId === e.userId);
            });
        }
    }
}
</script>

<style scoped>
.choose-people-container {
    width: 100%;
}
.choose-people-link {
    width: 100%;
}
.choose-people-tags {
    margin-top: 5px;
}
.choose-people-body {
    display: flex;
    width: 100%;
    height: 420px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
}
.org-list-container {
    width: 220px;
    height: 100%;
    border-right: 1px solid #ebeef5;
    display: flex;
    flex-direction: column;
}
.org-list-title {
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    background-color: #f5f7fa;
    font-weight: bold;
    color: #377f7f;
    border-bottom: 1px solid #ebeef5;
}
.org-list-content {
    flex: 1;
    overflow-y: auto;
}
.org-item {
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.org-item:hover {
    background-color: #f5f7fa;
}
.org-item-active {
    background-color: #eaf4f4;
    color: #377f7f;
    font-weight: bold;
}
.user-list-container {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.user-list-title {
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    background-color: #f5f7fa;
    font-weight: bold;
    color: #377f7f;
    border-bottom: 1px solid #ebeef5;
}
.user-list-content {
    flex: 1;
    padding: 10px;
    overflow-y: auto;
}
.user-search-box {
    padding: 10px;
    border-bottom: 1px solid #ebeef5;
}
.user-grid {
    display: flex;
    flex-wrap: wrap;
}
.user-card {
    width: 33.33%;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    border-radius: 4px;
    transition: background-color 0.2s;
}
.user-card:hover {
    background-color: #f5f7fa;
}
.user-card-active {
    background-color: #eaf4f4;
}
.user-card-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f5f7fa;
}
.user-card-check {
    padding-top: 3px;
    margin-right: 8px;
}
.user-card-info {
    flex: 1;
    min-width: 0;
}
.user-card-name {
    font-size: 14px;
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 22px;
}
.user-card-phone {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    line-height: 18px;
}
.user-empty {
    text-align: center;
    color: #909399;
    padding: 40px 0;
    font-size: 14px;
}
.dis-flex-row-center {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
